module.exports = __webpack_public_path__ + "static/media/membership.12cf9918.jpg";